/* Copyright 2019 Google LLC All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  ==============================================================================*/

// Reorder the labels in order to group similar categories.
const reorderedLabels = [0, 6, 2, 4, 3, 5, 7, 9, 1, 8];

function process(data) {
  const originalToReordered = {};
  reorderedLabels.forEach(
    (oldIndex, newIndex) => (originalToReordered[oldIndex] = newIndex)
  );
  data.labels = data.labels.map(index => {
    return originalToReordered[index];
  });

  const originalLabels = [...data.labelNames];
  data.labelNames = reorderedLabels.map(index => {
    return originalLabels[index];
  });
  return data;
}

export async function loadData() {
  const res = await fetch(`fmnist_tsne_vs_umap.json`);
  const json = await res.json();
  return process(json);
}
